<div style="display: flex;">
    <p-dialog [(visible)]="showAbout" header="About" [modal]="true">
        <div class="grid border-round" style="min-width: 46rem;">
            <!--ABOUT-->
            <div class="col col-12">
                <div class="surface-card border-round text-left shadow-2 p-3" style="height: 100%">
                    <!-- <span class="text-xl text-left font-medium text-90">About</span> -->
                    <div class="p-4">
                        <div class="p-2 mb-4 flex">
                            <span class="p-float-label w-full">
                                <input class="w-full" type="text" id="admincount" pInputText [(ngModel)]="eFAACTVersion"
                                    readonly>
                                <label for="admincount">eFAACT Version</label>
                            </span>
                        </div>
                        <div class="p-2 mb-4 flex">
                            <span class="p-float-label w-full">
                                <input class="w-full" type="text" id="admincount" pInputText
                                    [(ngModel)]="eFAACTApiVersion" readonly>
                                <label for="admincount">eFAACT API Version</label>
                            </span>
                        </div>
                        <div class="p-2 mb-4 flex">
                            <span class="p-float-label w-full">
                                <input class="w-full" type="text" id="admincount" pInputText
                                    [(ngModel)]="softwareLicenseAgreementLink" readonly>
                                <label for="admincount">License Agreement</label>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </p-dialog>

</div>

<p-dialog [(visible)]="showProcessInfo" [modal]="false" [style]="{ width: '20vw', 'min-width': '20vw', 'max-width': '30vw' }">
    <ng-template #header>
        <label style="font-size: 1.25rem;">
            <i class="pi pi-info-circle"></i>
            {{ currentProcess?.ProcessTitle }}
        </label>
    </ng-template>
    <p>{{ currentProcess?.ProcessDesc }}</p>

    <ng-template #footer>
        <a id="lnk-help" #documentation *ngIf="currentProcess?.UrlDocumentation"
            [href]="currentProcess?.UrlDocumentation" target="_blank" data-toggle="tooltip" data-placement="top"
            title="Documentation" trigger="hover">
            <button pButton pRipple type="button" icon="pi pi-book"></button>
        </a>
        <a id="lnk-demo" #demo *ngIf="currentProcess?.UrlDemo" [href]="currentProcess?.UrlDemo" target="_blank"
            data-toggle="tooltip" data-placement="top" title="Short Introduction" trigger="hover">
            <button pButton pRipple type="button" icon="pi pi-video"></button>
        </a>
    </ng-template>
</p-dialog>


<div class="layout-topbar" [ngClass]="{
            'border-bottom-none': layoutService.layoutConfig().topbarTheme !== 'light'
        }">
    <div class="layout-topbar-start">

        <ng-container *ngIf="( this.app.userInfo$ | async ) as info;" >
            <a class="layout-topbar-logo-slim text-white logo-hover-switch" (click)="this.app.onMenuHomeClick($event)" id="topbarLogo">
                <img
                    *ngIf="this.layoutService.layoutConfig().menuMode === 'slim'"
                    class="layout-sidebar-logo-slim logo-img"
                    [src]="'../../../images/eflogotransparent-avalon-dark.png'"
                    alt="eF"
                    style="width: 40px; height: 40px;"
                />
                <span
                    *ngIf="this.layoutService.layoutConfig().menuMode === 'slim'"
                    class="layout-topbar-home-icon logo-home"
                >
                    <i class="pi pi-home mx-2" style="font-size: 1.5rem;"></i>
                </span>
                <i
                    *ngIf="this.layoutService.layoutConfig().menuMode === 'reveal'"
                    class="pi pi-home mx-2"
                    style="font-size: 1.5rem;"
                ></i>
            </a>
            <a class="text-white company-title" *ngIf="this.app.hasCompanyURL === true" href="#" (click)="this.app.openUserManual()">
                <label class='font-medium mb-0 ml-4' id="companyTitle">{{ info.CompanyName }}</label>
            </a>
            <label *ngIf="this.app.hasCompanyURL !== true" class='company-title font-medium mb-0 ml-4 text-white' id="companyTitle">{{
                info.CompanyName }}</label>
        </ng-container>
        <!-- <div class="company-title float-left">
                <a class="layout-topbar-logo text-white" [uiSref]="'main'">
                    <i class="pi pi-home mx-2" style="font-size: 1.5rem;"></i>
                    <h4 style="margin-top: 0.6rem;">{{ app.title }}</h4>
                </a>
            </div> -->

        <!--If the menumode is not reveal, this menuButton is needed-->
        <!-- <a #menuButton class="layout-menu-button" (click)="onMenuButtonClick()" pRipple>
                <i class="pi pi-angle-right"></i>
            </a> -->
    </div>

    <p-popover #op appendTo="body">
        {{ currentProcess?.ProcessDesc }}
    </p-popover>
    <div class="layout-topbar-center">
        <div class="layout-topbar-actions-center">
            <ul class="layout-topbar-items">
                <li>
                    <h2 #processTitle>
                        <label (click)="op.show($event)" style="cursor: help;" class="font-medium">{{ currentProcess?.ProcessTitle }}</label>
                    </h2>
                </li>
                <li>
                    <a
                        *ngIf="currentProcess?.ProcessDesc || currentProcess?.UrlDocumentation || currentProcess?.UrlDemo"
                        target="_blank"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Process Information"
                        trigger="hover"
                        (click)="showProcessInfo = !showProcessInfo"
                        class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-info-circle"
                            href="javascript:;"
                            style="cursor: help; font-size: 1.2rem; font-weight: 200; margin-top: 0.25rem;">
                        </i>
                    </a>
                </li>
                <!-- <li>
                    <a id="lnk-help" #documentation *ngIf="currentProcess?.UrlDocumentation"
                        [href]="currentProcess?.UrlDocumentation" target="_blank" data-toggle="tooltip" data-placement="top"
                        title="Documentation" trigger="hover">
                        <i class="pi pi-book" style="font-size: 1.5em;"></i>
                    </a>
                </li>
                <li>
                    <a id="lnk-demo" #demo *ngIf="currentProcess?.UrlDemo" [href]="currentProcess?.UrlDemo" target="_blank"
                        data-toggle="tooltip" data-placement="top" title="Short Introduction" trigger="hover">
                        <i class="pi pi-video" style="font-size: 1.5em;"></i>
                    </a>
                </li> -->
            </ul>
        </div>
    </div>

    <div class="layout-topbar-end">
        <div class="layout-topbar-actions-end">
            <ul class="layout-topbar-items">
                <li #reportsSideNav id="efreportsSideNav" [ngClass]="{
                            'active-top-menu': app.activeTopbarItem === reportsSideNav
                        }">
                    <a data-toggle="tooltip" data-placement="top" title="Reports" href="#"
                        (click)="app.onReportButtonClick($event)">
                            <i class="topbar-icon pi pi-file" style="font-size: 1.5rem;"></i>
                    </a>
                </li>
                <li #errorsSidenav id="efErrorsSideNav" style="position: relative;">
                    <a #errorsToggle (click)="toggleDropdown('errors')" data-toggle="tooltip" data-placement="top" title="Notifications">
                        <i class="topbar-icon pi pi-exclamation-circle" style="font-size: 1.5rem;"></i>
                        <span [ngClass]="{'hidden': !this.app.errorCount}"
                            class="errors-badge text-xs border-round bg-red-500 text-white">
                            {{ this.app.errorCount }}
                        </span>
                    </a>

                    <div #errorsDropdown class="errors-dropdown" [class.hidden]="!isDropdownOpen('errors')">
                        <!-- Debug: Dropdown is {{ isDropdownOpen('errors') ? 'OPEN' : 'CLOSED' }} -->
                        <ef-errors-sidenav-wrapper></ef-errors-sidenav-wrapper>
                        <!-- Fallback content for testing -->
                        <div *ngIf="!app.errorCount" style="padding: 10px; color: #666;">
                            No notifications to display
                        </div>
                    </div>

                </li>
                <li>
                    <a #helpToggle (click)="toggleDropdown('help')" title="Help" data-toggle="tooltip" data-placement="top">
                        <i class="pi pi-question-circle" style="font-size: 1.5rem;"></i>
                    </a>
                    <div #helpDropdown [class.hidden]="!isDropdownOpen('help')" class="help">
                        <ul class="list-none p-0 m-0">
                            <li>
                                <a class="py-2 px-3 flex gap-2 cursor-pointer text-color hover:text-primary"
                                    data-toggle="tooltip" data-placement="top" (click)="openHelpDesk()" href="#">
                                    <span>eFAACT Help Desk</span>
                                </a>
                            </li>
                            <li>
                                <a class="py-2 px-3 flex gap-2 cursor-pointer text-color hover:text-primary"
                                    uiSref="helpdesk">
                                    <span>eFAACT Guide</span>
                                </a>
                            </li>
                            <li>
                                <a class="py-2 px-3 flex gap-2 cursor-pointer text-color hover:text-primary"
                                    uiSref="usermanual" (click)="openUserManual()" href="#">
                                    <span>eFAACT User Manual</span>
                                </a>
                            </li>
                            <li>
                                <a class="py-2 px-3 flex gap-2 cursor-pointer text-color hover:text-primary"
                                    href=" https://efaactcentral.com/releasenotes/efaactreleasenotes.htm"
                                    target="_blank">
                                    Release Notes
                                </a>
                            </li>
                            <li>
                                <a class="py-2 px-3 flex gap-2 cursor-pointer text-color hover:text-primary"
                                    (click)="openAbout()">
                                    <span>About</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
                <li class="mx-2">
                    <a *ngIf="this.layoutService.layoutConfig().darkTheme == false"
                        title="Switch to Dark Mode" data-toggle="tooltip" data-placement="top"
                        (click)="this.toggleTheme()">
                        <i class="pi pi-fw pi-moon" style="font-size: 1.5rem;"></i>
                    </a>
                    <a *ngIf="this.layoutService.layoutConfig().darkTheme == true"
                        title="Switch to Light Mode" data-toggle="tooltip" data-placement="top"
                        (click)="this.toggleTheme()">
                        <i class="pi pi-fw pi-sun" style="font-size: 1.5rem;"></i>
                    </a>
                </li>
                <li class="layout-topbar-search">
                    <p-autoComplete
                        #searchInput
                        id="searchbar"
                        showClear="true"
                        placeholder="Search..."
                        [forceSelection]="false"
                        [(ngModel)]="selectedProcess"
                        [suggestions]="this.processTitles"
                        (completeMethod)="filterProcessFromSearch($event)"
                        (onSelect)="gotoProcessFromSearch($event)"
                        (onClear)="onSearchClear()"
                        (onFocus)="onSearchFocus()"
                        (onBlur)="onSearchBlur()"
                        [minLength]="1"
                        [dropdown]="false">
                    </p-autoComplete>
                    <i class="pi pi-search search-icon"
                       [class.hidden]="isSearchFocused || hasSearchValue"
                       (click)="focusSearch()"></i>
                </li>
                <li class="mx-4">
                    <a #helpToggle (click)="toggleDropdown('profile')" title="Logout & User Profile" data-toggle="tooltip" data-placement="top">
                        <i class="pi pi-user" style="font-size: 1.5rem;"></i>
                    </a>
                    <div #profileDropdown [class.hidden]="!isDropdownOpen('profile')" class="profile">
                        <div class="p-3 pt-0 border-bottom flex flex-column align-items-center">
                            <span class="text-900 pb-0 text-xl font-medium">{{this.app.userInfo?.EmployeeName}}</span>
                            <div>
                                <small *ngIf="this.app.userRoles && this.app.userRoles.length > 0">{{this.app.userRoles[0].GroupName}}</small>
                            </div>
                        </div>
                        <ul class="list-none p-0 m-0">
                            <li>
                                <a class="py-2 px-3 flex gap-2 cursor-pointer text-color hover:text-primary"
                                    data-toggle="tooltip" data-placement="top" (click)="this.app.onProfileMySettingsClick();">
                                    <div class="flex align-items-center">
                                        <i class="pi pi-cog mr-2"></i>
                                        <span>My Settings</span>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a class="py-2 px-3 flex gap-2 cursor-pointer text-color hover:text-primary"
                                    uiSref="password" (click)="this.app.onChangePasswordClick(null)">
                                    <div class="flex align-items-center">
                                        <i class="pi pi-key mr-2"></i>
                                        <span>Change Password</span>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a class="py-2 px-3 flex gap-2 cursor-pointer text-red-500 hover:text-red-800"
                                    href="#"
                                    (click)="this.app.onSignout($event)">
                                    <div class="flex align-items-center">
                                        <i class="pi pi-power-off mr-2"></i>
                                        <span>Logout</span>
                                    </div>

                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
                <!-- <li>
                        <button pButton pRipple type="button" class="app-config-button p-button-text" (click)="onConfigSidebarToggle()">
                            <i class="pi pi-palette"></i>
                        </button>
                    </li> -->
            </ul>
        </div>

    </div>
</div>
